import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconViewWeekComponent } from "./med-icon-view-week.component";

@NgModule({
  declarations: [
    MedIconViewWeekComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconViewWeekComponent,
  ],
})
export class MedIconViewWeekModule { }
